/* eslint-disable no-underscore-dangle */
import React, { useMemo, useRef } from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import MeetingModel from '@/models/meeting';
import s from './index.less';
import ReactionModel from '@/models/reaction';
import { Tooltip } from 'antd';
import { useHover } from 'ahooks';
import { meeting } from '@/models';
import { message } from '@/components';
interface EmoItemProps {
  meeting?: MeetingModel;
  reaction?: ReactionModel;
  emo?: any;
  hostEnableEmoList: boolean;
}

const EmoItem: React.FC<EmoItemProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
    reaction: store.reaction,
  };
})(
  observer((props) => {
    const { hostEnableEmoList, emo } = props;
    const { formatMessage } = useIntl();
    const imgRef = useRef<any>(null);
    const isHovering = useHover(imgRef);

    const handleSendEmo = () => {
      if (!hostEnableEmoList) {
        return message.info({
          content: formatMessage({ id: 'meetingReactionsAreDisabled' }),
          noIcon: true,
        });
      } else {
        API.api.reaction.sendEmoticon
          .request({}, { channelId: meeting?.info?.channelId, emoticonId: emo?.emoticonId })
          .then((res) => {
            message.info({
              content: formatMessage({ id: 'emojiSent' }),
              noIcon: true,
            });
          });
      }
    };
    const imgSrc = useMemo(() => {
      if (isHovering) {
        return emo.animateUrl;
      }
      return emo.defaultUrl;
    }, [isHovering, emo]);

    return (
      <div className={s.emoItem} ref={imgRef} onClick={handleSendEmo}>
        <Tooltip
          title={emo.emoticonName}
          align={{ offset: [18, 8] }}
          placement="bottom"
          zIndex={2000}
          overlayClassName={s.tooltip}
        >
          <img src={imgSrc} className={s.emo} />
        </Tooltip>
      </div>
    );
  })
);
export default EmoItem;
